import { Box, styled } from '@mui/material'

import { AppHeader } from '@/components/AppHeader'
import { ThemeToggle } from '@/components/ThemeToggle'

interface MainLayoutProps {
  children: React.ReactNode
  title?: React.ReactNode
  subtitle?: React.ReactNode
  search?: React.ReactNode
  actions?: React.ReactNode
}

const StyledContainer = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  backgroundColor: theme.palette.background.default,
}))

const FixedBottomRight = styled(Box)({
  position: 'fixed',
  bottom: 16,
  right: 16,
  zIndex: 1000,
})

export const MainLayout = ({ children, title, subtitle, search, actions }: MainLayoutProps) => {
  return (
    <StyledContainer>
      <AppHeader title={title} subtitle={subtitle} search={search} actions={actions} />
      {children}
      <FixedBottomRight>
        <ThemeToggle />
      </FixedBottomRight>
    </StyledContainer>
  )
}
